"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flex = exports["default"] = void 0;
var flex = exports.flex = {
  horizontal: "\n    display: flex;\n    flex-direction: row;\n  ",
  horizontalInline: "\n    display: inline-flex;\n    flex-direction: row;\n  ",
  vertical: "\n    display: flex;\n    flex-direction: column;\n  ",
  verticalInline: "\n    display: inline-flex;\n    flex-direction: column;\n  ",
  flexWrap: "\n    display: flex;\n    flex-wrap: wrap;\n  ",
  centerHorizontal: "\n    justify-content: center;\n    align-items: center;\n  ",
  wrap: "\n    flex-wrap: wrap;\n  ",
  centerHorizontalH: "\n    justify-content: center;\n  ",
  centerHorizontalV: "\n    align-items: center;\n  ",
  centerVertical: "\n    align-items: center;\n    justify-content: center;\n  ",
  centerVerticalReset: "\n    align-item: initial;\n    justify-content: initial;\n  ",
  centerVerticalH: "\n    align-items: center;\n  ",
  centerVerticalV: "\n    justify-content: center;\n  ",
  spaceAround: "\n    justify-content: space-around;\n  ",
  spaceBetween: "\n    justify-content: space-between;\n  ",
  justifyEnd: "\n    justify-content: flex-end;\n  ",
  justifyStart: "\n    justify-content: flex-start;\n  ",
  // Disable the content-based minimum size suggestion
  // https://css-tricks.com/flexbox-truncated-text/#article-header-id-3
  allowOverflowX: "\n    flex-basis: 0; // IE11\n    min-width: 0;\n  ",
  allowOverflowY: "\n    flex-basis: 0; // IE11\n    min-height: 0;\n  "
};
var _default = exports["default"] = flex;
//# sourceMappingURL=flex.js.map